import React, { useState } from 'react';
import useCollapse from 'react-collapsed';
import { ReactComponent as ArrowHead } from '../../../assets/images/arrowHead.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setSideNav } from '../../../state/sidenavSlice';
import { useSelector } from 'react-redux/es/exports';
import { IRootState } from '../../../state/store';
import './CollapsibleMenu.scss';

interface IMenuItem {
  text: string;
  link: string;
}

interface CollapsibleMenuProps {
  menuItems?: IMenuItem[];
  titleText: string;
  image: string;
  selectedImage?: string;
}

const CollapsibleMenu: React.FC<CollapsibleMenuProps> = ({ menuItems, titleText, image, selectedImage }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const currentRoute = location.pathname;

  const [collapsed, setCollapsed] = useState<boolean>(!false);

  const state = useSelector((state: IRootState) => state.sideNav);
  const { getCollapseProps, getToggleProps, isExpanded, setExpanded } = useCollapse({
    isExpanded: state.selectedHeader === titleText && collapsed,
  });
  const menuItemLinks = menuItems?.map((item: IMenuItem) => {
    return item.link;
  });
  return (
    <div
      className="collapsibleMenuComponent"
      onClick={() => {
        if (state.selectedHeader === titleText) {
          setCollapsed(!collapsed);
        }
        dispatch(
          setSideNav({
            selectedHeader: titleText,
          }),
        );
      }}>
      <div
        className="titleContainer"
        {...getToggleProps()}
        style={{ color: state.selectedHeader === titleText ? '#075453' : '' }}>
        <div className="titleTextAndImage">
          <div className="titleImage">
            <img src={image} hidden={menuItemLinks?.includes(currentRoute)} alt="" />
            <img src={selectedImage} alt="" hidden={!menuItemLinks?.includes(currentRoute)} />
          </div>
          <div className="titleText" style={{ color: menuItemLinks?.includes(currentRoute) ? '#075453' : '#353d47' }}>
            {titleText}
          </div>
        </div>
        <div className={isExpanded ? 'rotatedTitleIcon' : 'titleIcon'}>
          <ArrowHead />
        </div>
      </div>
      <div {...getCollapseProps()} style={{ marginBottom: '-10px' }}>
        <div className="menuItemRowContainer">
          {menuItems &&
            menuItems.map((item: IMenuItem) => {
              return (
                <div
                  key={`${item.text}_${item.link}`}
                  onClick={() => {
                    navigate(item.link);
                  }}
                  className="menuItemRow"
                  style={{
                    backgroundColor: item.link === currentRoute ? '#E5F4F2' : '',
                    color: item.link === currentRoute ? '#075453' : '',
                  }}>
                  {item.text}
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default CollapsibleMenu;
